<div class="loading-screen-wrapper" *ngIf="loading">
    <div class="loading-screen-icon">
      <!-- Loader -->
      <div class="blobs">
          <div class="blob-center"></div>
          <div class="blob"></div>
          <div class="blob"></div>
          <div class="blob"></div>
          <div class="blob"></div>
          <div class="blob"></div>
          <div class="blob"></div>
        </div>        
    </div>
</div>